import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseEstablishmentPermissionsOperationKlassesProps<T> = {
  filters?: {
    search?: string
  }
  mapper?: (data: any) => T,
}

export const useEstablishmentPermissionsOperationKlasses = <T,>({
  filters: { search = '' } = {},
  mapper = Mapper.default<T>(),
}: UseEstablishmentPermissionsOperationKlassesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['establishmentPermissionsOperationKlasses', search],
    queryFn: () => {
      return privateAxios.get(`/establishment/permissions/operation_klasses`, {
        params: {
          search,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
